<template>
    <div>
        <CRow>
            <CCol md="12" class="mb-5">
                <CCard>
                    <CCardHeader>
                        <CRow>


                            <CCol col="4" style="text-align: start">
                                <strong>{{$t('components.driverDocumentList')}} {{ driver_name }}</strong>

                            </CCol>
                            <CCol col="4" style="text-align: center">
                            </CCol>
                            <CCol col="4" style="text-align: end">

                            </CCol>
                        </CRow>
                    </CCardHeader>
                    <CCardBody>
                                <CRow>
                                    <CCol col="4">
                                        <treeselect
                                                v-model="refer_person"
                                                :async="true"
                                                :load-options="load_persons"
                                                :placeholder="$t('components.searchUser')"
                                                :normalizer="normalizer_persons"
                                        />

                                    </CCol>
<!--                                  <CCol col="3">-->
<!--                                    <date-picker-->

<!--                                        :label="$t('tables.date')"-->
<!--                                        v-model="refer_date"></date-picker>-->
<!--                                    </CCol>-->
                                </CRow>
                                <CDataTable
                                        :items="items_buy"
                                        :fields="fields"
                                        :sorter-value="{column:'masterFactorId', asc:false}"
                                        :items-per-page="20"
                                        hover
                                        sorter
                                        column-filter
                                        pagination
                                >
                                    <template #row="{item}">

                                        <td>
                                            <p style="text-align:center">{{item.row_id+1}}</p>

                                        </td>

                                    </template>
                                    <template #date="{item}">

                                        <td>
                                            <p>{{get_date(item.createdAt)}}</p>

                                        </td>

                                    </template>

                                    <template #warehouse="{item}">
                                        <td>
                                            <p>{{item.placeName}}</p>

                                        </td>

                                    </template>
                                    <template #price="{item}">

                                        <td>
                                            <!--                                          <strong >{{item.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g,-->
                                            <!--                                              ",")}} </strong>-->
                                            <!--                                          -->
                                            <p style="text-align: right">{{get_currency(item.price)}} </p>

                                        </td>


                                    </template>
                                    <template #customer="{item}">

                                        <td>
                                            <p>{{item.personName}}</p>

                                        </td>

                                    </template>
                                    <template #summary="{item}">

                                        <td>
                                            <p>{{item.masterFactorTitle}}</p>

                                        </td>

                                    </template>


                                    <template #operation="{item,index}">
                                        <td>
                                            <CButton
                                                    color="danger"
                                                    variant="outline"
                                                    square
                                                    size="sm"
                                                    @click="delete_item_dialog(item,index)"
                                            >{{$t('buttons.cancelRefer')}}
                                            </CButton>
                                            <CButton
                                                    color="primary"
                                                    variant="outline"
                                                    square
                                                    size="sm"
                                                    @click="goShowDocument(item,index)"
                                            >{{$t('buttons.show')}}
                                            </CButton>
                                            <CButton
                                                    color="success"
                                                    square
                                                    size="sm"
                                                    @click="goPrintDocument(item,index)"
                                            >{{$t('buttons.print')}}
                                            </CButton>
                                        </td>
                                    </template>


                                </CDataTable>

                   </CCardBody>
                    <CCardFooter>

                    </CCardFooter>
                </CCard>

                <CCard id="printMe_products">
                    <CCardHeader>
                        <strong>{{$t('components.temporaryDocumentsProducts')}}</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CDataTable
                                :items="items_products"
                                :fields="fields_products"

                                :items-per-page="200"
                                hover
                                sorter
                                pagination
                        >
                            <template #row="{item}">

                                <td>
                                    <strong>{{item.row_id+1}}</strong>

                                </td>

                            </template>
                            <template #product="{item}">

                                <td>
                                    <strong>{{item.productName}}</strong>

                                </td>

                            </template>

                            <template #qty="{item}">
                                <td>
                                    <strong style="text-align:center">{{Math.abs(item.productCount/item.unitValue)}}</strong>

                                </td>

                            </template>
                            <template #weight="{item}">

                                <td>
                                    <strong>{{item.weight}}</strong>

                                </td>


                            </template>
                            <template #unit="{item}">

                                <td>
                                    <strong>{{item.productUnitName}}</strong>

                                </td>

                            </template>


                        </CDataTable>

                    </CCardBody>
                    <CCardFooter>

                    </CCardFooter>
                </CCard>
                <CButton @click="print_products()" size="sm"
                         color="primary">
                    <CIcon name="cil-check-circle"/>
                    {{$t('buttons.print')}}
                </CButton>
            </CCol>
        </CRow>

    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';

    import Treeselect from '@riophae/vue-treeselect'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {ASYNC_SEARCH} from '@riophae/vue-treeselect'

    import Vue from 'vue';
    import VueHtmlToPaper from 'vue-html-to-paper';
    // import FilterHeader from "../includes/FilterHeader";
    const options = {
        name: '_blank',
        specs: [
            'fullscreen=yes',
            'titlebar=yes',
            'scrollbars=yes',
        ],
        styles: [
            'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
            'https://unpkg.com/kidlat-css/css/kidlat.css',

        ]
    }

    Vue.use(VueHtmlToPaper, options);


    var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }
    var items_data = [];


    export default {
        name: 'Login',
        components: {
            // FilterHeader,
            Treeselect,
            'test-dynamic': () => import('../documents/PrintDocument'),

        },
        data() {
            return {
                show_document: 'test-dynamic',

                name: '',
                file: '',
                driver_name: '',
                color: '#ffffff',
                previewImage: '',
                submit_refer: 0,
                refer_person: null,
                refer_date: null,
                selected_template: 0,
                description: null,
                items_buy: items_data.map((item, row_id) => {
                    return {...item, row_id}


                }),
                items_final: items_data.map((item, row_id) => {
                    return {...item, row_id}


                }),

                items_products: [],
                fields: [
                    {key: 'row', label: this.$t('tables.row'), _style: 'width:5%'},
                    {key: 'masterFactorCode', label: this.$t('tables.factorId'), _style: 'width:10%'},
                    {key: 'warehouse', label: this.$t('tables.warehouse'), _style: 'width:10%'},
                    {key: 'price', label: this.$t('tables.price'), _style: 'width:10%'},
                    {key: 'customer', label: this.$t('tables.customer'), _style: 'width:10%'},
                    {key: 'date', label: this.$t('tables.referDate'), _style: 'width:5%'},
                    {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},

                ],

                fields_products: [
                    {key: 'row', label: this.$t('tables.row'), _style: 'width:3%;padding:0px'},
                    {key: 'product', label: this.$t('tables.product'), _style: 'width:20%;padding:0px'},
                    {key: 'qty', label: this.$t('tables.qty'), _style: 'width:5%;padding:0px'},
                    {key: 'weight', label: this.$t('tables.weight'), _style: 'width:7%;padding:0px'},
                    {key: 'unit', label: this.$t('tables.unit'), _style: 'width:5%;padding:0px'},

                ],


                details: [],
                templates_items: [
                    {template_id: 'One', name: 'A'},
                    {template_id: 'Two', name: 'B'},
                    {template_id: 'Three', name: 'C'}
                ],
                collapseDuration: 0,
                status_form: 0,
                load_persons({action, searchQuery, callback}) {

                    if (action === ASYNC_SEARCH) {
                        simulateAsyncOperation(() => {
                            let options;
                            const formData = new FormData();

                            formData.append('SearchTxt', searchQuery);
                            var url = "GetAllPersons";

                            formData.append('IsVendor', false);
                            formData.append('IsWorker', true);
                            formData.append('IsCustomer', false);
                            formData.append('IsActive', 0);

                            axios.post(url, formData, {show_pros: true}).then(function (response) {
                                options = response.data.data;

                                callback(null, options);

                            })
                                .catch(function (error) {

                                    console.log(error);
                                });

                        })
                    }
                },
                normalizer_persons(node) {
                    return {
                        id: node.userId,
                        label: node.personCode + " " + node.userName + " " + node.surName + " " + node.mobileNo,
                    }
                },
            }
        },
        mounted() {

            this.$root.root_validate_errors = [];
          this.get_lists_buy();


            // this.get_lists_buy();
            // this.get_lists_final();
            // this.get_lists_products();

            bus.$on('delete_confirm_cancel_refer' + this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == "true") {
                    this.delete_item();

                } else {
                    this.status_form = 0;
                }
            });

            // this.$watch(
            //     () => {
            //       return this.$refs.filter_bar.start_date
            //     },
            //     (val) => {
            //       alert('App $watch $refs.counter.i: ' + val)
            // this.get_lists_buy();
            // this.get_lists_final();
            // this.get_lists_products();
            // })
            // this.$watch(
            //     () => {
            //       return this.$refs.filter_bar.end_date
            //     },
            //     (val) => {
            //       alert('App $watch $refs.counter.i: ' + val)
            // this.get_lists_buy();
            // this.get_lists_final();
            // this.get_lists_products();
            // })
        }, watch: {
            'refer_person': function () {
              if (this.refer_person!=null){
                this.get_lists_buy();
                // this.get_lists_final();
                // this.get_lists_products();
              }

            },
        'refer_date': function () {
                this.get_lists_buy();
                // this.get_lists_final();
                // this.get_lists_products();
            },

        },
        methods: {
            get_style(color) {
                return {
                    myStyle: {
                        backgroundColor: color
                    }
                }
            },

            print_products() {
                // Pass the element id here
                this.$htmlToPaper('printMe_products');
            },
            print() {
                // Pass the element id here
                this.$htmlToPaper('printMe');
            },
            edit_item(item) {
                // this.$set(this.items[item.id], '_toggled', !item._toggled)
                this.name = this.items[item.row_id].unitName;
                this.color = this.items[item.row_id].color;
                this.description = this.items[item.row_id].description;
                this.previewImage = this.items[item.row_id].image;
                this.status_form = this.items[item.row_id].id;
                // this.$nextTick(() => {
                //     this.collapseDuration = 0
                // })
            },
            emptyList() {
                // this.$set(this.items[item.id], '_toggled', !item._toggled)
                this.name = '';
                this.color = '';
                this.description = '';
                this.previewImage = '';
                this.status_form = 0;

                // this.$nextTick(() => {
                //     this.collapseDuration = 0
                // })
            },
            get_lists_buy() {
                var self = this;


                const formData = new FormData();

                var url = "GetFactorRetResult";


                // formData.append("Status", 0);

              if(this.refer_date!=null){
                // formData.append("FDate", this.refer_date);
                formData.append("DriverId", this.refer_person);
              }else{
                formData.append("DriverId", 0);

              }
                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.items_buy = content_data.data.map((item, row_id) => {
                            return {...item, row_id}

                        });
                        // self.driver_name = response.data.data.UserName;
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },


            goEditPerson(item, index) {

                this.$router.push({path: '/dashboard/users/edit-user/' + this.items[index].userId});
                // this.$router.push({route_name: 'create_product' });
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },
            goShowDocument(item, index) {

                this.$router.push({path: '/dashboard/documents/show/' + item.masterFactorId});
                // this.$router.push({route_name: 'create_product' });
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },
            goPrintDocument(item, index) {
                bus.$emit("print_confirm", item.masterFactorId);

                // this.$router.push({route_name: 'create_product' });
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },
            AddRefer(item, index) {
                this.submit_refer = item.recId;
                // this.$router.push({path: '/dashboard/documents/show/' + item.recId});
                // this.$router.push({route_name: 'create_product' });
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },

            delete_item_dialog(item, index) {
                this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], 'delete_confirm_cancel_refer' + this.confirm_delete_name);

                this.status_form = item.masterFactorId;
            },
            delete_item() {


                let self = this;
                const formData = new FormData()
                let url;
                url = "CancelFactorRefer";


                formData.append('id', this.status_form);

                axios.post(url, formData, {}).then((res) => {

                    self.$root.modal_component.show_api_response_modals(res);

                    self.status_form = 0;

                    self.get_lists_buy();

                })
                    .catch(function (error) {

                        console.log(error);
                    });
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },

        },

    }

</script>
